<template>
  <div class="picview">
    <div class="piccontainer">
      <div class="item" v-for="(pic,index) in pics">
        <div class="pic">
          <!--<popover-img :img-src="pic.url?picAddr + pic.url : ''" ></popover-img>-->
          <a :href="pic.url ? picAddr + pic.url: ''" target="_blank">
            <img :src="pic.url?picAddr + pic.url : ''" />
          </a>
        </div>
        <div class="viewtext">
          <div class="contents">
            <div :class="{showtext : pic.showText}">
            <div class="content" v-for="content in pic.contents">{{content}}</div>
            </div>
          </div>
          <!--<div class="sort"><div>{{pic.sort}}</div></div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PopoverImg from './../common/PopoverImg'
  export default {
    props: ['pics'],
    data () {
      return {}
    },
    created () {
    },
    methods: {
    },
    components: {PopoverImg},
    computed: {
      ...mapState({
        picAddr: state => state.picAddr
      })
    }
  }
</script>

<style lang="stylus">
  .picview
    .piccontainer
      display flex
      padding-top 10px
      align-items flex-start
      flex-wrap wrap
      .item
        box-shadow 0 2px 12px 0 rgba(0, 0, 0, .1)
        display flex
        justify-content center
        align-items center
        flex-direction column
        border 1px solid #ebeef5
        background-color #fff
        transition .3s
        overflow hidden
        margin 5px
        border-radius 2px
        width 32%
        padding 10px
        .pic
          display flex
          justify-content center
          align-items center
          height 200px
          /*overflow hidden*/
          img
            max-height 200px
            max-width 100%
        .viewtext
          padding-top 10px
          text-align center
          .contents
            line-height 20px
            overflow hidden
            font-size 12px
            .showtext
              height 100px
            .content
              &:first-child
                font-weight bold
                font-size 14px
          .sort
            padding-top 5px
            display flex
            justify-content center
            div
              width 20px
              height 20px
              line-height 20px
              border-radius 50%
              background-color rgb(244, 244, 245)
</style>



// WEBPACK FOOTER //
// PicView.vue?251f921a